<template>
  <div class="hr-post" v-loading="isLoading">
    <header-top></header-top>
    <div class="header-title">职务职级配置</div>

    <div class="post-container">
      <div class="container-tip">
        <svg-icon icon-class="icon-tips" class="icon-tips" />
        <ul>
          <svg-icon icon-class="tips-bg" class="icon-tips-bg" v-if="showTips" />
          <li class="tips-tit">
            小贴士
            <i
              class="el-icon-caret-top tips-btn"
              v-if="showTips"
              @click="showTip"
            ></i>
            <i
              class="el-icon-caret-bottom tips-btn"
              v-else
              @click="showTip"
            ></i>
          </li>
          <li v-if="showTips">
            <span></span>
            <div>
              添加职务后，可关联权限组，用户绑定职务后，将启用权限组上的权限
            </div>
          </li>
          <li v-if="showTips">
            <span></span>
            <div>一个职务可关联多个权限组，关联后以最大权限为主</div>
          </li>
          <li v-if="showTips">
            <span></span>
            <div>
              一个职务下可包含多个职级，创建职务职级时请以公司实际人事架构为准
            </div>
          </li>
        </ul>
      </div>
      <div class="container-main">
        <div class="main-left">
          <div class="left-operation">
            <div class="operation-btn">
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">添加</div>
                <div @click="addPost">
                  <svg-icon icon-class="add-ico" class="btn-add" />
                </div>
              </el-tooltip>
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">刷新</div>
                <div @click="searchPosts">
                  <svg-icon icon-class="refresh-ico" class="btn-refresh" />
                </div>
              </el-tooltip>
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">删除</div>
                <div @click="delPost">
                  <svg-icon icon-class="del-ico" class="btn-del" />
                </div>
              </el-tooltip>
            </div>
            <el-input
              class="post-search"
              placeholder="请输入标签名称"
              suffix-icon="el-icon-search"
              v-model="postSearch"
              v-if="postAll.length"
              clearable
            ></el-input>
          </div>
          <div class="post-items" v-show="postAll.length">
            <el-tree
              class="custom-tree"
              lazy
              :data="posts"
              :props="{ children: 'children', isLeaf: 'isLeaf' }"
              :load="loadTreeNodes"
              v-loading="treeLoading"
              empty-text=""
              @node-click="nodeClick"
            >
              <span class="custom-tree-node" slot-scope="{ data }">
                <span>{{ data.data.name }}</span>
                <el-tooltip
                  placement="top"
                  popper-class="custom-tooltip"
                  effect="light"
                >
                  <div slot="content">添加下级</div>
                  <span @click.stop="addPost(data)">
                    <svg-icon icon-class="add-ico" class="btn-append" />
                  </span>
                </el-tooltip>
              </span>
            </el-tree>
          </div>
        </div>

        <div class="main-right" v-show="operation == 'create' || posts.length">
          <el-form
            label-position="left"
            v-if="isEdit"
            label-width="4rem"
            ref="postForm"
            :rules="postRules"
            :model="form"
          >
            <div class="edit-view" v-if="form.positionDepth == 'post'">
              <div class="view-title" v-if="operation == 'create'">
                添加新职务
              </div>
              <div class="view-title" v-else>编辑职务</div>
              <el-form-item label="名称" prop="name" class="auto-height">
                <el-input
                  v-model="form.name"
                  placeholder="请输入职务名称"
                  clearable
                ></el-input>
                <div class="form-tip">
                  仅支持中文、英文、数字、_、-，不超过30个字符
                </div>
              </el-form-item>
              <el-form-item label="别名">
                <el-input
                  v-model="form.alias"
                  placeholder="请输入职务别名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="是否开启">
                <el-radio-group v-model="form.status">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="类型">
                <el-radio-group v-model="form.positionType">
                  <el-radio-button
                    :label="key"
                    v-for="(item, key) in identityPositionTypeDic"
                    :key="key"
                    >{{ item }}</el-radio-button
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item class="transfer-form-item" label="权限组">
                <div class="transfer-select" @click="openFiltrate">
                  <span class="placeholder" v-if="!roles.length"
                    >请选择权限组</span
                  >
                  <div
                    class="select-item"
                    v-for="(item, index) in roles"
                    v-show="index < 2"
                    :key="index"
                  >
                    <span>{{ item }}</span>
                    <div
                      class="del-fixed-item"
                      @click.stop="delPermissionItem(index)"
                    >
                      <svg-icon icon-class="close-ico"></svg-icon>
                    </div>
                  </div>
                  <div v-if="roles.length > 2">...</div>
                  <div class="suffix">
                    <i
                      class="el-icon-circle-close"
                      @click.stop="permissionForm = []"
                      v-if="roles.length"
                    ></i>
                    <i
                      class="el-icon-caret-bottom"
                      :class="{ 'inline-block': !roles.length }"
                    ></i>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="备注" class="auto-height">
                <el-input
                  type="textarea"
                  v-model="form.description"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                ></el-input>
                <div class="form-tip">
                  仅支持中文、英文、数字、_、-，不超过200个字符
                </div>
              </el-form-item>
              <div class="group-btn">
                <el-button
                  type="primary"
                  @click="saveInfo"
                  :loading="subLoading"
                  >保存</el-button
                >
                <el-button @click="cancel">取消</el-button>
              </div>
            </div>
            <div class="edit-view" v-else>
              <div class="view-title" v-if="operation == 'create'">
                添加新职级
              </div>
              <div class="view-title" v-else>编辑职级</div>
              <!-- <el-form-item label="所属职务">{{ post.name }}</el-form-item> -->
              <el-form-item label="名称" prop="name" class="auto-height">
                <el-input
                  v-model="form.name"
                  placeholder="请输入职级名称"
                  clearable
                ></el-input>
                <div class="form-tip">
                  仅支持中文、英文、数字、_、-，不超过30个字符
                </div>
              </el-form-item>
              <el-form-item label="别名">
                <el-input
                  v-model="form.alias"
                  placeholder="请输入职级别名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="是否开启">
                <el-radio-group v-model="form.status">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="类型">
                <el-radio-group v-model="form.positionType">
                  <el-radio-button label="Business">业务</el-radio-button>
                  <el-radio-button label="Function">职能</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item class="transfer-form-item" label="权限组" v-if="post.positionDepth=='职务'">
                <div class="transfer-select" @click="openFiltrate">
                  <span class="placeholder" v-if="!roles.length"
                    >请选择权限组</span
                  >
                  <div
                    class="select-item"
                    v-for="(item, index) in roles"
                    v-show="index < 2"
                    :key="index"
                  >
                    <span>{{ item }}</span>
                    <div
                      class="del-fixed-item"
                      @click.stop="delPermissionItem(index)"
                    >
                      <svg-icon icon-class="close-ico"></svg-icon>
                    </div>
                  </div>
                  <div v-if="roles.length > 2">...</div>
                  <div class="suffix">
                    <i
                      class="el-icon-circle-close"
                      @click.stop="permissionForm = []"
                      v-if="roles.length"
                    ></i>
                    <i
                      class="el-icon-caret-bottom"
                      :class="{ 'inline-block': !roles.length }"
                    ></i>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="备注" class="auto-height">
                <el-input
                  type="textarea"
                  v-model="form.description"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                ></el-input>
                <div class="form-tip">
                  仅支持中文、英文、数字、_、-，不超过200个字符
                </div>
              </el-form-item>
              <div class="group-btn">
                <el-button
                  type="primary"
                  @click="saveInfo"
                  :loading="subLoading"
                  >保存</el-button
                >
                <el-button @click="cancel">取消</el-button>
              </div>
            </div>
          </el-form>
          <div class="info-view" v-else-if="post.name">
            <div class="view-title">
              {{ post.name }}
              <div class="edit-btn" @click="editPost">管理</div>
            </div>
            <div class="info-item">
              <div class="info-label">名称</div>
              {{ post.name | nullValue }}
            </div>
            <div class="info-item">
              <div class="info-label">别名</div>
              {{ post.alias | nullValue }}
            </div>
            <!-- <div class="info-item">
              <div class="info-label">{{ post.positionDepth }}类型</div>
              {{ post.positionType }}
            </div> -->
            <div class="info-item">
              <div class="info-label">是否开启</div>
              {{ post.status ?"是":"否" }}
            </div>
            <div class="info-item" v-if="post.positionDepth == '职务'">
              <div class="info-label">权限组</div>
              <span
                class="permission-item"
                v-for="(item, index) in post.roles"
                :key="index"
                v-show="post.roles.length"
                >{{ item.name }}</span
              >
              <span v-show="!post.roles.length">—</span>
            </div>
            <div class="info-item">
              <div class="info-label">备注</div>
              {{ post.description | nullValue }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择权限"
      :visible.sync="isFiltrateShow"
      width="800px"
      :before-close="permissionGroupClose"
      custom-class="filter-dialog"
    >
      <el-transfer
        filterable
        :titles="['可选择权限组', '已加入权限组']"
        filter-placeholder="请输入权限组名称"
        v-model="permissionForm"
        :data="tabTitData"
        :filter-method="filterMethod"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPermissionItems">取消</el-button>
        <el-button type="primary" @click="isFiltrateShow = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import headerTop from "@/components/HeaderTop";
import { getAllRoles } from "@/http/api/role";
import {
  getPostAllTree,
  getPostTree,
  deletePost,
  getPostInfo,
  createPost,
  updatePost,
} from "@/http/api/position";
import { debounce } from "@/utils/debounce";

export default {
  components: {
    headerTop,
  },
  data() {
    return {
      postSearch: "",
      operation: "",
      selectedId: "",
      isLoading: true,
      tabTitData: [],
      isEdit: false,
      subLoading: false,
      isFiltrateShow: false,
      search: "",
      operation: "",
      identityPositionTypeDic: this.$store.getters.enumMetadata
        .IdentityPositionType,
      postRules: {
        name: [{ required: true, message: "请输入职务名称", trigger: "blur" }],
      },
      posts: [],
      postAll: [],
      post: {
        positionType: "Business",
      },
      rolesAll: [],
      form: {},
      postelected: {},
      postNode: {},
      appendData: {},
      permissionForm: [],
      originalRoles: [],
      showTips: true,
      permissions: this.$store.getters.permissions,
      treeLoading: false,
    };
  },
  mounted() {
    this.searchPosts();
    this.getRoles();
    this.$watch(
      "postSearch",
      debounce((val) => {
        this.searchPosts();
      }, 200)
    );
  },
  computed: {
    roleIds() {
      let ids = [];
      if (this.permissionForm.length) {
        this.permissionForm.map((item) => {
          ids.push(item.split(" ")[0]);
        });
      }
      return ids;
    },
    roles() {
      let names = [];
      if (this.permissionForm.length) {
        this.permissionForm.map((item) => {
          names.push(item.split(" ")[1]);
        });
      }
      return names;
    },
  },
  methods: {
    showTip() {
      this.showTips = !this.showTips;
    },
    getRoles() {
      getAllRoles().then((res) => {
        this.rolesAll = res.result.items;
        this.rolesAll.forEach((item, index) => {
          this.tabTitData.push({
            label: item.name,
            key: item.id + " " + item.name,
          });
        });
      });
    },
    loadTreeNodes(val, resolve) {
      var node = val.data.data;
      if (node) {
        let query = {
          parentId: node.id,
          loadMode: "async",
          maxResultCount: 1000,
        };
        getPostTree(query).then((res) => {
          resolve(res.result.items);
        });
      }
    },
    // 搜索职位
    searchPosts() {
      this.treeLoading = true;
      if (this.postSearch) {
        let query = {
          loadMode: "async",
          filter: this.postSearch,
          maxResultCount: 1000,
        };
        getPostTree(query)
          .then((res) => {
            this.posts = res.result.items;
            if (this.posts.length) {
              this.getPostInfo(this.posts[0].data.id);
              this.selectedId = this.posts[0].data.id;
            }
            this.treeLoading = false;
          })
          .catch((err) => {
            this.treeLoading = false;
          });
      } else {
        getPostTree({ loadMode: "async", maxResultCount: 1000 })
          .then((res) => {
            this.postAll = res.result.items;
            this.posts = this.postAll;
            if (this.posts.length) {
              this.getPostInfo(this.posts[0].data.id);
              this.selectedId = this.posts[0].data.id;
            }
            this.isLoading = false;
            this.treeLoading = false;
          })
          .catch((err) => {
            this.treeLoading = false;
          });
      }
    },
    // 获取职位详情
    getPostInfo(id) {
      getPostInfo(id).then((res) => {
        this.post = res.result;
        this.getInfoRoles();
      });
    },
    getInfoRoles() {
      let arr = [],
        ids = [];
      this.post.roles.map((item) => {
        arr.push(item.id + " " + item.name);
        ids.push(item.id);
      });
      this.permissionForm = arr;
    },
    // 删除节点
    delPost() {
      //console.log(this.post, 111);
      if (this.post.isDefault) {
        this.$message.warning({
          message: `默认职务职级不可删除`,
          showClose: true,
        });
      } else {
        if (this.permissions["RocketIdentity.Positions.Delete"]) {
          if (this.operation == "checked") {
            let text = this.post.parentId ? "职级" : "职位";
            this.$confirm(`此操作将永久删除该${text}, 是否继续?`, "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            })
              .then(() => {
                deletePost(this.selectedId).then((res) => {
                  if (res) {
                    this.$message.success({
                      message: "删除成功",
                      showClose: true,
                    });
                  }                  
                  this.searchPosts();
                  this.operation = "";
                });
              })
              .catch(() => {
                //console.log("已取消");
              });
          }
        } else {
          this.$message.warning({
            message: `您暂无删除职务职级权限`,
            showClose: true,
          });
        }
      }
    },
    // 添加职位
    addPost(data) {
      if (this.permissions["RocketIdentity.Positions.Create"]) {
        this.form = {
          positionType: "Business",
        };
        this.permissionForm = [];
        let parentId = this.post.parentId;
        if (data.data) {
          // 职务添加下级
          //console.log(this.post, "this.post");
          //console.log(data.data, "data.data");
          this.selectedId = data.data.id;
          this.form.positionDepth = "position";
        } else if (parentId) {
          // 职级添加同级
          this.selectedId = parentId;
          this.form.positionDepth = "position";
        } else {
          // 添加职务
          this.selectedId = "";
          this.form.positionDepth = "post";
        }
        this.operation = "create";
        this.isEdit = true;
      } else {
        this.$message.warning({
          message: `您暂无添加职务职级权限`,
          showClose: true,
        });
      }
    },
    // 点击节点
    nodeClick(node, data) {
      this.operation = "checked";
      this.isEdit = false;
      this.selectedId = node.data.id;
      this.getPostInfo(this.selectedId);
    },
    delPermissionItem(index) {
      this.permissionForm.splice(index, 1);
    },
    cancelPermissionItems() {
      this.permissionForm = this.originalRoles;
      this.isFiltrateShow = false;
    },
    openFiltrate() {
      this.originalRoles = this.permissionForm;
      this.isFiltrateShow = true;
    },
    permissionGroupClose() {
      this.isFiltrateShow = false;
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    editPost() {
      //console.log(this.permissions["RocketIdentity.Positions.Update"], 123);
      if (this.permissions["RocketIdentity.Positions.Update"]) {
        this.isEdit = true;
        this.operation = "edit";
        this.form = deepCopy(this.post);
        this.form.positionType =
          this.form.positionType == "业务" ? "Business" : "Function";
        this.form.positionDepth =
          this.form.positionDepth == "职务" ? "post" : "position";
        this.getInfoRoles();
      } else {
        this.$message.warning({
          message: `您暂无管理职务职级权限`,
          showClose: true,
        });
      }
    },
    saveInfo() {
      this.$refs.postForm.validate((valid) => {
        if (valid) {
          this.subLoading = true;
          if (this.operation == "create") {
            if (this.selectedId) {
              this.form.parentId = this.selectedId;
            }
            this.form.roles = this.roleIds;
            createPost(this.form)
              .then((res) => {
                if (res.code == 10200) {
                  this.$message.success({
                    message: "添加成功",
                    showClose: true,
                  });
                  this.searchPosts();
                  this.subLoading = false;
                }
              })
              .catch((err) => {
                this.subLoading = false;
              });
          } else if (this.operation == "edit") {
            this.form.roles = this.roleIds;
            updatePost(this.form.id, this.form)
              .then((res) => {
                if (res) {
                  this.$message.success({
                    message: "修改成功",
                    showClose: true,
                  });
                  this.getPostInfo(this.selectedId);
                }
                this.subLoading = false;
              })
              .catch((err) => {
                this.subLoading = false;
              });
          }
          this.isEdit = false;
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    cancel() {
      this.operation = "";
      this.isEdit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.hr-post {
  height: calc(100vh - 50px);
  overflow-y: auto;
  text-align: left;
  .title {
    color: #000000;
    font-size: 16px;
    font-weight: bold;
    padding: 17px 20px 17px;
    background: rgba(255, 255, 255, 1);
  }

  .svg-icon {
    cursor: pointer;
  }

  .post-container {
    padding: 20px;
    .container-tip {
      @include flex(row, flex-start);
      margin-bottom: 20px;
      padding: 20px;
      font-size: 12px;
      font-weight: 500;
      background: #fff;
      .icon-tips {
        color: $--color-primary;
        padding: 10px 0;
      }
      ul {
        margin: 0;
        position: relative;
        padding-left: 10px;
        width: 100%;
        .icon-tips-bg {
          position: absolute;
          right: 0px;
          bottom: -94px;
          font-size: 250px;
        }
        li {
          @include flex(row, center);
          margin-bottom: 10px;
          width: 100%;
          span {
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
            padding: 2px;
            background: #111;
          }
        }
        .tips-tit {
          justify-content: space-between;
          .tips-btn {
            position: relative;
            z-index: 99;
            padding: 10px;
            cursor: pointer;
          }
        }
        li:last-child {
          margin-bottom: 0px;
        }
      }
    }

    .container-main {
      display: flex;

      .main-left {
        border-radius: $--border-radius-base;
        margin-right: 20px;
        padding: 20px;
        width: 315px;
        background: #fff;
        .left-operation {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .operation-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;

            width: 50px;

            .el-tooltip {
              height: 16px;
              &:first-child {
                // height: 10px;
              }
            }

            .btn-add {
              width: 10px;
              height: 10px;
              vertical-align: baseline;
            }
            .btn-refresh {
              width: 15px;
              height: 18px;
              margin: 0 10px;
            }
            .btn-del {
              width: 16px;
              height: 16px;
              color: #888;
            }
          }

          .post-search {
            width: 220px;
            height: 30px;
          }
        }

        .post-items {
          margin-top: 20px;

          .custom-tree {
            ::v-deep .el-tree-node__children {
              .el-tooltip {
                display: none;
              }
            }
          }
        }
      }

      .main-right {
        border-radius: $--border-radius-base;
        overflow: hidden;
        padding: 20px;
        width: calc(100% - 354px);
        background: #fff;
        // min-height: calc(100vh - 268px);

        .view-title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 25px;
          position: relative;
          z-index: 99;
          font-size: 14px;
          font-weight: bold;
          color: #000;

          .edit-btn {
            font-size: 14px;
            font-weight: 400;
            color: $--color-primary;
            cursor: pointer;
          }
        }

        .info-view {
          .view-title {
            margin-bottom: 30px;
          }
          .info-item {
            display: flex;
            align-items: center;
            margin-bottom: 30px;

            font-size: 14px;
            font-weight: 400;
            color: #000;

            .info-label {
              width: 5rem;
              color: #888;
            }
          }
        }

        .edit-view {
          .el-form-item {
            .el-textarea,
            .el-select,
            .el-input {
              width: 330px;
            }
          }

          .width {
            width: 90%;
          }

          .tip-svg {
            position: relative;
            top: 1px;
            margin-left: 5px;
            width: 14px;
            height: 14px;
            color: #9e9e9e;
          }

          .group-btn {
            margin: 12px 0 10px 4rem;
          }
        }

        .permission-item {
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }
        }

        .edit-btn {
          color: $--color-primary;
          cursor: pointer;
        }
      }
    }

    // .min-height {
    // min-height: calc(100vh - 258px);
    // }
  }
}
</style>